import { AgoraVideoPlayer } from "agora-rtc-react";
import React, { useContext } from "react";
import { usersConected } from "../../../context/CamsConected/CamsConected";
import { ContactData } from "../../../context/ContactData/ContactData";

function CameraDistributionRecordin() {
  const { speakers, screens, tracks, localScreen, usersDisconectedImage } =
    useContext(usersConected);

  const { dataContact, skin, videIsMuted } = useContext(ContactData);
  const {
    room: { attendee },
  } = dataContact;

  return (
    <div
      className={`marginTop${skin} cams-recording`}
    >
      {tracks && tracks[1] && screens.length > 0 && !videIsMuted && (
        <div className="miniCams mt-20">
          <AgoraVideoPlayer className="vid-minicams" videoTrack={tracks[1]} />
          <div className={`minicams-name${skin}`}>{attendee.name}</div>
        </div>
      )}

      {tracks && tracks[1] && localScreen && !videIsMuted && (
        <div className="miniCams mt-20">
          <AgoraVideoPlayer className="vid-minicams" videoTrack={tracks[1]} />
          <div className={`minicams-name${skin}`}>{attendee.name}</div>
        </div>
      )}

      {localScreen &&
        speakers.length > 0 &&
        speakers.map((user) => (
          <div className="miniCams mt-20" key={user.uid}>
            {!user._video_muted_ && user.videoTrack ? (
              <AgoraVideoPlayer
                videoTrack={user.videoTrack}
                className="vid-minicams"
              />
            ) : (
              <img
                src={`${process.env.REACT_APP_CONTACT_IMG}/fondo-sin-cam-1.jpg`}
                alt="agora-video"
                className="vid-minicams"
              />
            )}
            <div className={`minicams-name${skin}`}>{user.userName}</div>
          </div>
        ))}

      {localScreen && videIsMuted && (
        <div className="miniCams mt-20">
          <img
            src={`${process.env.REACT_APP_CONTACT_IMG}/fondo-sin-cam-1.jpg`}
            alt="agora-video"
            style={{ width: "100%", height: "calc(100% - 30px)" }}
          />

          <div className={`minicams-name${skin}2`}>{attendee.name}</div>
        </div>
      )}

      {screens.length > 0 && videIsMuted && (
        <div className="miniCams mt-20">
          <img
            src={`${process.env.REACT_APP_CONTACT_IMG}/fondo-sin-cam-1.jpg`}
            alt="agora-video"
            style={{ width: "100%", height: "calc(100% - 30px)" }}
          />
          <div className={`minicams-name${skin}`}>{attendee.name}</div>
        </div>
      )}

      {screens.length > 0 &&
        speakers.length > 0 &&
        speakers.map((user) => (
          <div className="miniCams mt-20" key={user.uid}>
            {!user._video_muted_ && user.videoTrack ? (
              <AgoraVideoPlayer
                videoTrack={user.videoTrack}
                className="vid-minicams"
              />
            ) : (
              <img
                src={`${process.env.REACT_APP_CONTACT_IMG}/fondo-sin-cam-1.jpg`}
                alt="agora-video"
                className="vid-minicams"
              />
            )}
            <div className={`minicams-name${skin}`}>{user.userName}</div>
          </div>
        ))}
    </div>
  );
}

export default CameraDistributionRecordin;
